// These icons types are from the CMS
// Do not change/update values without also updating
// cms -> collections -> landing.yml
export enum FAIconTypes {
  Recruitment = "recruitment",
  HybridInfrastructure = "hybrid-infra",
  SaasPlatforms = "saas-platforms",
  DevOps = "devops",
  Ai = "ai",
  AppDev = "appdev",
  CyberSecurity = "cybersec",
  IOT = "internet-of-things",
  Consulting = "consulting",
}
